/**
 * Slate Mobile Navigation Menu
 *
 */
( function( $ ) {

    'use strict';

	/**
	 * 'is_mobile' variable to determine if this is a mobile size.
	 */
	var set_is_mobile, is_mobile = false;

	(set_is_mobile = function() {
		is_mobile = !! jQuery( '#menu-toggle' )[0].offsetParent;
	})();

	jQuery( window ).on( 'resize', debounce(set_is_mobile, 200) );

	/**
	 * Toggle menu open/closed when clicking menu toggle
	 */
	$( '#menu-toggle' ).click( function() {
		$( this ).toggleClass( 'open' );
		$( '#menu' ).toggleClass( 'open' );
		$('body').toggleClass('opened-menu');

		if ($(this).hasClass('open')) {
			$(this).attr('aria-expanded', true)
		} else {
			$(this).attr('aria-expanded', false);
		}
	});

	function close_menu() {
		$( '#menu-toggle' ).removeClass( 'open' );
		$( '#menu' ).removeClass( 'open' );
		$( 'body' ).removeClass( 'opened-menu' );
		$('#menu-toggle').attr('aria-expanded', false);
		$('#menu-toggle').focus();
	}

	//Hide the search bar after click out of it
	jQuery('#content').on('click',function(e){
		if ($('#menu-toggle').hasClass('open')) {
			close_menu();
		}
	});

	jQuery(window).on('keyup', function (e) {
		if ( e.keyCode == 27 ) { // escape key maps to keycode `27`
			close_menu();
		}
	});

	/**
	 * Toggle Submenus open/closed when clicking appropriate submenu toggle
	 */
	$( '.submenu-toggle' ).each( function() {
		var focus_out_timer = null;
		var toggle_button = jQuery( this );
		var submenu = toggle_button.parent();

		toggle_button.click( function() {
			submenu.toggleClass( 'open' );
			toggle_button.toggleClass( 'open' );
			if ($(this).hasClass('open')) {
				toggle_button.attr('aria-expanded', true)
			} else {
				toggle_button.attr('aria-expanded', false);
			}
		});


		/**
		 * If we have focused on another anchor tag in this submenu clear the
		 * timer to remove the open classes.
		 */
		submenu.find( 'a, button' ).on( 'focus', function() {
			if ( is_mobile ) { return; }
			if ( focus_out_timer ) {
				clearTimeout( focus_out_timer );
				focus_out_timer = null;
			}
		});

		/**
		 * When leaving a menu anchor tag, set a timer to clear the open
		 * classes.
		 */
		submenu.find( 'a, button' ).on( 'blur', function() {
			if ( is_mobile ) { return; }
			focus_out_timer = setTimeout(function () {
				submenu.removeClass( 'open' );
				toggle_button.removeClass( 'open' );
				toggle_button.attr('aria-expanded', false);
			}, 100);
		});
	});

})( jQuery );
